import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import PlatformNav from "./components/PlatformNav";
import GameLibrary from "./components/GameLibrary";
import DownloadGuide from "./components/DownloadGuide";
import FaqSection from "./components/FaqSection";
import AboutSection from "./components/AboutSection";
import { faqs } from "@/mocks/games";

function seoJsonLd() {
  const data = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "火影同人游戏库",
      url: "https://shengdi365.cn/",
      inLanguage: "zh-CN",
      potentialAction: {
        "@type": "SearchAction",
        target: {
          "@type": "EntryPoint",
          urlTemplate: "https://shengdi365.cn/?s={search_term_string}",
        },
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
  ];
  return JSON.stringify(data);
}

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: seoJsonLd() }} />
      <Navbar />
      <main>
        <Hero />
        <PlatformNav />
        <GameLibrary />
        <DownloadGuide />
        <FaqSection />
        <AboutSection />

        <section className="relative overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=wide%20anime%20style%20banner%20of%20two%20ninjas%20in%20orange%20attire%20facing%20each%20other%20in%20a%20ready%20pose%20at%20sunset%20over%20a%20ninja%20village%2C%20warm%20orange%20and%20crimson%20tones%2C%20epic%20and%20dynamic%2C%20high%20detail%20digital%20painting&width=1600&height=500&seq=cta-naruto&orientation=landscape"
            alt="火影同人游戏下载行动号召背景图"
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-black/60"></div>
          <div className="relative z-10 mx-auto flex max-w-4xl flex-col items-center px-4 py-20 text-center md:py-24">
            <h2 className="font-heading text-3xl font-bold text-white md:text-4xl">
              准备好开启你的忍界冒险了吗？
            </h2>
            <p className="mt-4 max-w-xl text-sm leading-7 text-white/85 md:text-base">
              手机、电脑、安卓、汉化、免安装，总有一款适合你的火影同人游戏在等你。挑一个开始吧！
            </p>
            <a
              href="#library"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById("library")?.scrollIntoView({ behavior: "smooth" });
              }}
              className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-8 py-3.5 text-base font-semibold text-white transition-all hover:bg-primary-600 hover:-translate-y-0.5"
            >
              <i className="ri-download-2-line"></i>
              前往游戏资源库
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}